<ul>
  <li *ngFor="let item of log.logs; let i = index">
    {{item}}
  </li>
</ul>
